const MAX_VISIBLE_CHARACTERS = 240 as const;

export default { MAX_VISIBLE_CHARACTERS };
